export default __webpack_public_path__ + "65e425e98de2d54b9bb8c553628778f3.jpg";